import { cannotAccessList } from '@/assets/cannotAccessList'

export default {
    install(Vue, option) {
        Vue.prototype.$validate = new (function () {
            const DataValid = function (data) {
                if (data !== undefined && data !== null && data !== '') {
                    if (typeof data === 'object') {
                        return Object.keys(data).length > 0
                    } else if (Array.isArray(data)) {
                        return data.length > 0
                    }

                    if (data.length > 0) {
                        return data.trim().length > 0
                    }
                    return true;

                } else {
                    return false
                }
            }

            const regex = {
                email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                // phone: /^[2-9][0-9]{7}$/,
                phone: /^(\+?)[0-9]{2,18}$/i,
                hkMobile: /^[3-9][0-9]{7}$/,
                number: /^[0-9]+$/i,
                // floating: /^[0-9]+([.]?[0-9]{1,2})?$/i,
                floating: /^[0-9]+([.]?[0-9]{1})?$/i,
                floatingWithoutLimit: /^[0-9]+([.]?[0-9]+)?$/i,
                negativeNumber: /^[-]?[0-9]+$/i,
                negativeFloating: /^[-]?[0-9]+([.]?[0-9]+)?$/i,
                // blogSlug: /^[a-zA-Z0-9-_]+$/i
                blogSlug: /^[\u4e00-\u9fff\u3400-\u4dff\uf900-\ufaffA-za-z0-9-_]+$/i,
                hkid4Letter: /^[A-Z]{1,2}[0-9]{4}$/,
                date: /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
                regexIdNum: /^[a-zA-Z0-9]{8,9}$/i,
                hkPhone: /^(^[2|3|4|5|6|7|8|9])+([0-9]{7})$/,
                twPhone: /^(^[1-9])+([0-9]{8})$/,
                macauPhone: /^([0-9]{8})$/,
                chinaPhone: /^(^[1])+([0-9]{10})$/,
                chinName: /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\u3400-\u4DBF\u4E00-\u9FFF]{2,40}$/,
                engName: /^[a-zA-Z\s.,]{2,40}$/,
                password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                idFormat: /^#[0-9]+$/i,
                time: /^\d{2}:\d{2}$/, // 00:00
            }

            this.DataValid = data => {
                return DataValid(data);
            }

            this.required = value => {
                if (DataValid(value) && typeof value === 'string') {
                    return value.trim().length > 0
                }

                return DataValid(value);
            }

            this.isNumber = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'message.formRequired';
                    }
                }

                return regex.number.test(value) || 'message.pleaseEnterValidNumber'
            }

            this.regexNumber = (value) => {
                return regex.number.test(value);
            }

            this.isFloating = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'message.formRequired';
                    }
                }

                return regex.floatingWithoutLimit.test(value) || 'message.pleaseEnterValidNumber'
            }

            this.regexFloating = (value) => {
                return regex.floatingWithoutLimit.test(value);
            }

            this.isPhoneNumber = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'message.formRequired';
                    }
                }

                return regex.phone.test(value) || 'message.pleaseEnterValidPhone'
            }

            this.isEmail = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'message.formRequired';
                    }
                }

                return regex.email.test(value) || 'message.pleaseEnterValidEmail'
            }

            this.regexDateStr = (value) => {
                const valid = regex.date.test(value);
                if (!valid) {
                    return false;
                }

                const month = parseInt(value.substring(5, 7));
                if (month < 1 || month > 12) {
                    return false;
                }

                const daysInMonths = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                const date = parseInt(value.substring(8, 10));

                if (date < 1 || date > daysInMonths[month - 1]) {
                    return false;
                }

                return true;
            }

            this.isEngName = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'message.formRequired';
                    }
                }

                return regex.engName.test(value) || 'message.pleaseEnterValidEngName'
            }

            this.isValidPassword = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return 'message.formRequired';
                    }
                }

                return true;
            }

            this.isValidId = (value) => {
                return regex.idFormat.test(value)
            }

            this.checkDoubleFileExtension = (fileName) => {
                const extension = fileName.match(/\.(.+)$/)[1];

                if (extension.split(".").length !== 1) {
                    return true;
                }

                return false;
            }

            this.validateFileInput = (file, requiredExtension) => {
                // requiredType = img, video...
                // requiredExtension = png, jpg, mp4...

                const limitFileSize = 300

                let result = ''
                const fileType = file.type
                const format = fileType.split('/')[1]

                if (!requiredExtension.includes('*') && !requiredExtension.includes(format)) {
                    result = 'message.canOnlyUploadFormat'
                } else if (file.size / 1000 / 1000 > limitFileSize) {
                    result = 'message.fileSizeLimit'
                }

                return result
            }

            this.allowAction = (name, userType) => {
                if (
                    !userType ||
                    (cannotAccessList[name] &&
                        cannotAccessList[name].length &&
                        cannotAccessList[name].includes(userType))
                ) {
                    return false;
                }

                return true;
            }

            this.isQuotaUnused = (item) => {
                return item && item.course_category_id === -1 && !item.used && !item.used_count && (item.lesson === undefined || item.lesson < 0);
            }
            this.isUpgradeQuotaUnused = (item) => {
                return item && (item.used_count === undefined || item.used_count < 1) && (item.lessons === undefined || item.lessons.length < 1);
            }
            this.validateDeductAmount = (value, packageType, remainingPackageValue = null) => {
                if (!isNaN(value)) {
                    const amount = parseInt(value)

                    if (DataValid(remainingPackageValue)) {
                        if (amount <= parseInt(remainingPackageValue)) {
                            return true
                        }

                        return packageType === 'credit'
                            ? 'message.deductCreditExceedRemainingCredit'
                            : 'message.deductCreditExceedRemainingCredit'
                    } else {
                        return true
                    }
                }

                return false
            }

            this.isValidDate = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    return allowEmpty || 'message.formRequired';
                }

                return this.regexDateStr(value) || 'message.pleaseEnterValidDate';
            }
            this.isValidTime = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    return allowEmpty || 'message.formRequired';
                }

                if (regex.time.test(value)) {
                    const parts = value.split(':');
                    const hour = parseInt(parts[0]);
                    if (hour >= 0 && hour <= 24) {
                        if (parts.length > 1) {
                            const minute = parseInt(parts[1]);
                            if (minute >= 0 && minute <= 59) {
                                if (parts.length > 2) {
                                    const second = parseInt(parts[2]);
                                    if (second >= 0 && second <= 59) {
                                        return true
                                    }
                                } else {
                                    return true
                                }
                            }
                        }
                    }
                }

                return 'message.pleaseEnterValidTime';
            }
        })()
    }
}